import axios from "axios";

const getScanMap = (payload) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/analytic/api/v1/consumer/dashboard-scan-count", {
        start_date: payload.start_date,
        end_date: payload.end_date,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
};

export default getScanMap;
